import { StatusBar } from "expo-status-bar";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableWithoutFeedback,
  TextInput,
  ActivityIndicator,
  Platform,
  Alert,
  FlatList,
  Animated,
  Image,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import RichText from "app/components/RichText";
import Value from "app/components/Value";
import Timeline from "app/components/Timeline";
import TimelineNodes from "app/components/TimelineNodes";
import ValueNote from "app/components/ValueNote";
import ValueNoteList from "app/components/ValueNoteList";
import MultiButton from "app/components/MultiButton";

import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import prefActions from "app/utils/prefActions";
import keyboardHelpers from "app/utils/keyboardHelpers";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import draggableHelpers from "app/utils/draggableHelpers";
import timeHelpers from "app/utils/timeHelpers";
import clipboardHelpers from "app/utils/clipboardHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import {
  styleSheet,
  WIDTH,
  HEIGHT,
  CHILD_RATIO,
  PARENT_RATIO,
} from "app/utils/styleSheet";
import storageActions from "app/utils/storageActions";

import FilterBar from "app/components/FilterBar";
import Autocomplete from "app/components/Autocomplete";
import Canvas from "app/components/Canvas";
import DatePicker from "app/components/DatePicker";
import Generation from "app/components/Generation";
import Draggable from "app/components/Draggable";
import Hoverable from "app/components/Hoverable";
import Tooltip from "app/components/Tooltip";
import HoverableTooltip from "app/components/HoverableTooltip";
import ButtonGroup from "app/components/ButtonGroup";
import ProgressBar from "app/components/ProgressBar";

import MomentList from "app/components/chapter/MomentList";
import MomentBullet from "app/components/chapter/MomentBullet";
import MomentTimeline_Slats from "app/components/chapter/MomentTimeline_Slats";
import JourneyMap from "app/components/JourneyMap";
import MomentComposer from "app/components/chapter/MomentComposer";
import Badge from "app/components/chapter/Badge";
import Icon from "app/components/Icon";
import Tag from "app/components/chapter/Tag";
import ScratchPad from "app/components/ScratchPad";
import MomentsLog from "app/components/projects/MomentsLog";
import ReferenceList from "app/components/ReferenceList";
import AreaGraph from "app/components/AreaGraph";

import {
  Ionicons,
  Entypo,
  Feather,
  AntDesign,
  FontAwesome,
  MaterialIcons,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import store from "app/redux/store";
import { StyleContext } from "app/contexts/Style";

export default class ValueDash extends React.Component {
  static contextType = StyleContext;

  constructor(props, context) {
    super(props, context);

    let { route } = this.props;
    let id = route?.params?.id || 0;
    // if (!!id && id != "journal") id = parseInt(id);
    if (!!id && id != "journal") id = id;

    let { values, app } = store.getState();
    let value = values.find((v) => v.id == id) || { id };
    if (!!value?.color) {
      context.setUiColor(value.color);
    } else {
      context.setUiColor("default");
    }

    this.state = {
      id,
      value: null,
      // loading: app.loading,
      loading: true,
      loadingEvents: false,
      events: [],
      fetching: true,
      // pastRevisions: valueHelpers.getPastRevisions(value),
      // futureRevisions: valueHelpers.getFutureRevisions(value),
      // values,
      hideRevisions: true,
      showHistory: false,
      loadingHistory: false,
      moments: [],
      momentsChapters: [],
      revisions: [],
      scrollPos: 0,

      // layoutComplete: false,
      layoutComplete: context.pensieve ? false : true,
      bulkSelectIds: [],
      otherIsDragging: false,
      draggingValue: null,
      shelfThreshold: null,
      shelvedValues: [],
      tossedValueIds: [],
      draggingRow: null,
      showTimeline: context.pensieve ? true : false,
      graphMode: "moments",
      listView: false,
      diffX: 0,
      diffY: 0,
      sorting: {
        notes: "manual",
        active: "inherited",
        complete: "completed",
        inactive: "updated",
      },
      revision: {},
      revising: false,
      childrenLayout: "objects",
      childrenLayout: "lists",
      // childrenLayout: this.context.listLayout ? "lists" : "objects",
      sortChildrenBy: "progress",
      showNotes: false,
      hasNotes: false,
      showReferences: null,
      hiddenIds: [],
      subtasks: [],
      subtasksLoading: true,
      showValueNotes: false,
      showColumns: true,
      showCanvas: false,
      showMomentList: false,
      showMomentsLog: false,
    };
    this.SIZE = 150;
  }

  async componentDidMount() {
    if (ENV.WEB)
      document.addEventListener("keydown", keyboardHelpers.globalListener);
    this.subscribe();
    // focus
    // this.unsubscribeFocus = this.props.navigation.addListener(
    //   "focus",
    //   this.subscribe
    // );
    // this.unsubscribeBlur = this.props.navigation.addListener(
    //   "blur",
    //   this.unsubscribe
    // );
    // if (ENV.WEB) window.addEventListener("focus", this.refreshRedux);
    // if (ENV.WEB) window.addEventListener("blur", this.unsubscribe);

    await this.fetch();
    let { id } = this.state;
    let startRevising = [true, "true"].includes(
      this.props.route?.params?.revising,
    );
    if (startRevising) {
      this.startRevising();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if moments have changed
    const momentsChanged =
      this.state.moments?.length !== prevState.moments?.length ||
      this.state.moments?.some((m, i) => m?.id !== prevState.moments?.[i]?.id);

    if (momentsChanged) {
      // Check if any moments contain text content
      let showMomentsLog = !!this.state.moments?.find(
        (m) => !!m?.text?.length || !!m.title?.length,
      );
      if (!!showMomentsLog) {
        this.setState({ showMomentsLog });
      }
    }
  }

  componentWillUnmount() {
    // this.unsubscribeFocus && this.unsubscribeFocus();
    // if (ENV.WEB) window.removeEventListener("focus", this.subscribe);
    // this.unsubscribeBlur && this.unsubscribeBlur();
    // if (ENV.WEB) window.removeEventListener("blur", this.unsubscribe);
    // this.props.navigation.removeListener("focus");
    // if (ENV.WEB) window.removeEventListener("focus", this.handleFocus);
    this.unsubscribe();
    if (ENV.WEB)
      document.removeEventListener("keydown", keyboardHelpers.globalListener);
  }

  refreshRedux = () => {
    store.dispatch({ type: "app/update" });
  };

  subscribe = async () => {
    // this.navSub = this.props.navigation.addListener('willFocus', async (payload) => store.dispatch({type: 'app/update'}) );

    // let shelvedValues = await storageActions.fetchItem("shelvedValues", []);
    // await this.setState({ shelvedValues });

    // store.dispatch({ type: "app/update" });

    // console.log(this.state.id, "subscribing... /view");

    this.unsubscribeRedux = store.subscribe(() => {
      // let { value } = store.getState();
      // if (textHelpers.compareObjects(value, this.state.value)) return;
      // this.setState({value})

      let { values, app, preferences } = store.getState();
      // let { loading } = app;
      let value = values.find((v) => v.id == this.state.id) || {
        id: this.state.id,
      };
      if (textHelpers.compareObjects(value, this.state.value)) return;
      else console.log(this.state.id, "updating from store /view");
      // console.log(this.state.id, value, values);
      // let family = valueHelpers.getFamily(value);

      // let shelvedValues = this.state.shelvedValues;
      // let shelvedValuesIds = shelvedValues.map((v) => v.id);
      // shelvedValues = shelvedValues.map((v) => {
      //   if (shelvedValuesIds.includes(v.id)) {
      //     return values.find((sv) => sv.id == v.id);
      //   }
      //   return v;
      // });
      // storageActions.saveItem("shelvedValues", shelvedValues);

      this.setState({
        value,
        color: valueHelpers.getColor(value, this.context.colorScheme),
        hiddenIds: preferences.hiddenIds,
        // family,
        // values,
        // pastRevisions: valueHelpers.getPastRevisions(value),
        // futureRevisions: valueHelpers.getFutureRevisions(value),
        // shelvedValues,
        // loading,
      });
      // await new Promise((r) => setTimeout(r, 500));
    });

    // this.state.exploreScale.addListener(({value}) => this.exploreScaleValue = value);

    // focus
    // this.props.navigation.addListener("focus", this.handleFocus);
    // if (ENV.WEB) window.addEventListener("focus", this.handleFocus);
  };

  unsubscribe = () => {
    console.log(this.state.id, "unsubscribing /view", !!this.unsubscribeRedux);
    this.unsubscribeRedux && this.unsubscribeRedux();
  };

  handleFocus = () => {
    console.log("focusing");
    // this.setState({renderKey: this.state.renderKey+1})
  };

  fetch = async () => {
    // let values = await storageActions.fetchItem('values', [])
    // console.log(values)
    let { id } = this.state;
    // valueActions.get(id).then((res) => {
    //   this.setState({ loading: false, value: res.value });
    // });
    let valueRes = await valueActions.get(id);
    if (!valueRes?.value) { this.setState({ loading: false }); return; }
    let value = valueRes.value;

    // emit header color to Router
    // let color = valueHelpers.colorAsHex(value?.color, this.context.colorScheme);
    this.context.setUiColor(value?.color);
    if (ENV.WEB) document.title = value?.title;

    // this.setState({ loading: false, value: valueRes.value });
    // let pRes = await valueActions.getParents(id);
    // let cRes = await valueActions.getChildren(id);
    // when the value has journey data, open on the Narrative graph — but
    // only on first load so a manual toggle isn't fought on refreshes
    let graphMode = this.state.graphMode;
    if (!this._graphModeInitialized) {
      this._graphModeInitialized = true;
      try {
        let parsed = JSON.parse(value?.journey || "{}") || {};
        let beats = parsed.beats || {};
        let hasJourney =
          !!parsed.title?.length ||
          Object.keys(beats).some(
            (k) =>
              !!beats[k]?.text?.length || !!beats[k]?.value_ids?.length,
          );
        if (hasJourney) graphMode = "narrative";
      } catch (e) {}
    }

    this.setState({
      loading: false,
      value: value,
      color: valueHelpers.getColor(value, this.context.colorScheme),
      title: value?.title,
      id: value.id,
      referencers: valueRes.referencers,
      moments: valueRes.moments || [],
      momentsChapters: valueRes.chapters || [],
      graphMode,
    });

    await valueActions.getGrandParents([id]);
    await valueActions.getGrandChildren([id]);
    // this.fetchEvents();
    // let cRes = await valueActions.getChildren(id);

    // let fRes = await valueActions.getFamily(id, { up: 1, down: 1 });

    // console.log("family res", fRes);
    // console.log("familyres", res);
    // console.log("get family", res);
    // if (res) {
    //   console.log("view/value fetched index from id:", res);
    //   // value.viewTimeline = this.state.value.viewTimeline
    //   // this.setState({ loading: false, fetching: false });
    // } else {
    //   this.setState({ error: "Value not found" });
    // }
  };

  fetchEvents = async () => {
    this.setState({ loadingEvents: true });
    let { value } = this.state;
    let recursive = false;
    // attach the dash's fetched moments (they carry body text) so timeline
    // events can preview the story on hover
    let valueWithMoments = {
      ...value,
      moments: value.moments?.length ? value.moments : this.state.moments,
    };
    let events = valueHelpers.getTimeline(valueWithMoments, recursive);
    // if (allRevisions) {
    let revisions = valueHelpers.getRevisions(value);
    for (let r of revisions) {
      events = [...events, ...valueHelpers.getTimeline(r, recursive)];
    }
    // }
    events = textHelpers.uniq(events, "event_id");
    events = textHelpers.oldestFirst(events, "timestamp");
    console.log("EVENTS", events);
    this.setState({ events, loadingEvents: false });
  };

  fetchSubtasks = async () => {
    this.setState({ showSubtasks: true, subtasksLoading: true });
    let subtasks = await valueActions.getSubtasks(this.state.id);
    this.setState({ subtasksLoading: false });
    if (subtasks?.success) {
      this.setState({ subtasks: subtasks.values });
    }
  };

  addNewProgress = () => {
    // this.setState({newProgressAt: new Date().toUTCString()})
    this.setState({ newProgressAt: new Date() });
  };

  saveCheck = async (progressAt = null, note = null, onComplete = null) => {
    let { newProgressAt, value, newNote } = this.state;
    let timestamp = progressAt || newProgressAt;
    note = note || newNote;
    let updatedVal = await valueActions.createProgress(
      value,
      timestamp,
      note,
      false,
    );
    console.log(updatedVal.timeline);
    value = { ...value, timeline: updatedVal.timeline };
    this.setState({ value, newProgressAt: null, newNote: "" });
    onComplete && onComplete(value);
  };

  createChild = async (created_at, text, valueData = {}, onComplete = null) => {
    let { newProgressAt, value, newNote } = this.state;
    created_at = created_at || newProgressAt;
    text = text || newNote;
    let data = {
      created_at,
      text,
      parent_ids: [value.id],
      ...valueData,
    };
    let child = await valueActions.create(data);
    console.log(child);
    if (!!child) {
      // value.children.push(child)
      // value.child_ids.push(child.id)
      this.setState({ value, newProgressAt: null, newNote: "" });
      onComplete && onComplete(value);
    }
  };

  render() {
    let { navigation, route } = this.props;
    let {
      value,
      loading,
      fetching,
      newProgressAt,
      newNote,
      error,
      scrollHeight,
      lines,
      offset,
      layoutComplete,
      bulkSelectIds,
      otherIsDragging,
      shelvedValues,
      draggingValue,
      overlappedValue,
      draggingRow,
      listView,
      explorerView,
      exploreAnim,
      exploreScale,
      renderKey,
      hiddenIds,
      revising,
    } = this.state;

    return (
      <ScrollView
        ref={(r) => (this.scrollerRef = r)}
        scrollEventThrottle={120}
        onScroll={(event) => {
          const timestamp = Date.now();
          if (this.scrollEndTimeout) {
            clearTimeout(this.scrollEndTimeout);
          }
          if (this.lastScrollEvent) {
            // Scroll ended
            this.scrollEndTimeout = setTimeout(() => {
              if (this.lastScrollEvent === timestamp) {
                // console.log("still there! so scroll ended 500 ms ago");
                this.lastScrollEvent = null;
                // this.scrollPos = Math.round(event.nativeEvent.contentOffset.y);
                // this.scrollToHeader(true, 100);
              }
            }, 500);
          }

          this.lastScrollEvent = timestamp;
        }}
        style={[{ flex: 1 }]}
      >
        {value?.id != "journal" && (
          <View
            style={[this.styles().headerRow, !layoutComplete && { opacity: 0 }]}
          >
            <View style={this.styles().headerRowContent}>
              {/*<FilterBar navigation={this.props.navigation} noAutoFocus hideQuery />*/}
              <Autocomplete
                placeholder={"search"}
                ref={(r) => (this.autoCompleteRef = r)}
                globalSearch
                query={this.state.query || ""}
                onChangeText={(text) => {
                  this.setState({ query: text });
                }}
                simpleListView
                submitFirstOnPressEnter
                onSelectItem={(value, e) => {
                  RootNavigation.push("Project", { id: value.id }, e);
                }}
                onEnter={(value, e) => {
                  if (!!value) {
                    RootNavigation.push("Project", { id: value.id }, e);
                  } else {
                    !!this.autoCompleteRef && this.autoCompleteRef.fetchMore();
                  }
                }}
              />

              {!!error && (
                <Text
                  style={{ color: "red", padding: this.context.sizes.base }}
                >
                  {error}
                </Text>
              )}

              {/*<Text>level {value.level}</Text>*/}

              {/*<TouchableOpacity onPress={() => this.saveCheck(new Date())} style={this.styles().iconWrapper}>
                <Text underline>progress</Text><Feather name={'check-circle'} color={this.context.colors.foreground} style={this.styles().icon} />
              </TouchableOpacity>*/}

              {/*<TouchableOpacity
                onPress={() => this.setState({ listView: !listView })}
                style={this.styles().iconWrapper}
              >
                <Text underline>{listView ? "Nodes" : "List"}</Text>
              </TouchableOpacity>*/}

              {/*<TouchableOpacity
                onPress={() => this.setState({ explorerView: !explorerView })}
                style={this.styles().iconWrapper}
              >
                <Text underline>{explorerView ? "Static" : "Explorer"}</Text>
              </TouchableOpacity>*/}

              {/*<TouchableOpacity
              onPress={this.handleSnooze}
              style={this.styles().iconWrapper}
              disabled={loading}
            >
              <Text underline>
                {!!value?.soozed_until ? "remove snooze" : "snooze"}
              </Text>
              <FontAwesome
                name="moon-o"
                color={this.context.colors.foreground}
                style={this.styles().icon}
              />
            </TouchableOpacity>*/}

              <TouchableOpacity
                onPress={this.handleProgress}
                style={this.styles().iconWrapper}
                disabled={loading}
              >
                <Text underline>Progress</Text>
                <MaterialIcons
                  name={"check"}
                  color={this.context.colors.foreground}
                  style={[this.styles().icon, this.styles().iconRing]}
                />
              </TouchableOpacity>

              <TouchableOpacity
                onPress={this.handleComplete}
                style={this.styles().iconWrapper}
                disabled={loading}
              >
                <Text underline>
                  {!valueHelpers.getCompletedAt(value)
                    ? "Complete"
                    : "Uncomplete"}
                </Text>
                <MaterialIcons
                  name={"check-circle"}
                  color={this.context.colors.foreground}
                  style={[this.styles().icon, this.styles().iconRing]}
                />
              </TouchableOpacity>

              <TouchableOpacity
                onPress={this.handleArchive}
                style={this.styles().iconWrapper}
                disabled={loading}
              >
                <Text underline>
                  {!!value?.archived_at ? "Unarchive" : "Archive"}
                </Text>
                <Feather
                  name={"archive"}
                  color={this.context.colors.foreground}
                  style={this.styles().icon}
                />
              </TouchableOpacity>

              <TouchableOpacity
                onPress={this.handleCopyUrl}
                style={this.styles().iconWrapper}
              >
                <Text underline>Copy URL</Text>
                <Feather
                  name={"link"}
                  color={this.context.colors.foreground}
                  style={this.styles().icon}
                />
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => navigation.push("Network", { root_id: value.id })}
                style={this.styles().iconWrapper}
              >
                <Text underline>Network</Text>
                <MaterialCommunityIcons
                  name={"graph"}
                  color={this.context.colors.foreground}
                  style={this.styles().icon}
                />
              </TouchableOpacity>

              <TouchableOpacity
                onPress={this.handleHide}
                style={this.styles().iconWrapper}
                disabled={loading}
              >
                <Text underline>
                  {hiddenIds?.includes(value?.id) ? "Unhide" : "Hide"}
                </Text>
                <MaterialIcons
                  name={
                    hiddenIds?.includes(value?.id)
                      ? "visibility-off"
                      : "visibility"
                  }
                  color={this.context.colors.foreground}
                  style={this.styles().icon}
                />
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() =>
                  revising
                    ? this.setState({ revising: false })
                    : this.startRevising()
                }
                style={this.styles().iconWrapper}
                disabled={loading}
              >
                <Text underline>{revising ? "Cancel Revision" : "Revise"}</Text>
                <MaterialCommunityIcons
                  name="refresh"
                  color={this.context.colors.foreground}
                  style={this.styles().icon}
                />
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => navigation.push("Edit", { id: value.id })}
                style={this.styles().iconWrapper}
                disabled={loading}
              >
                <Text underline>Edit</Text>
                <AntDesign
                  name={"edit"}
                  color={this.context.colors.foreground}
                  style={this.styles().icon}
                />
              </TouchableOpacity>

              {/*!!value?.archived_at && (
              <TouchableOpacity
                onPress={() => RootNavigation.push("Revise", { id: value.id })}
                style={this.styles().iconWrapper}
                disabled={loading}
              >
                <Text underline>
                  {!!value?.archived_at ? "reopen" : "revise"}
                </Text>
                <MaterialCommunityIcons
                  name={"flag-variant"}
                  color={this.context.colors.foreground}
                  style={this.styles().icon}
                />
              </TouchableOpacity>
            )*/}
            </View>
          </View>
        )}

        <View
          style={{
            flex: 1,
            // minHeight: HEIGHT * 2
          }}
        >
          {loading ? <ActivityIndicator /> : this.renderContent()}
        </View>
      </ScrollView>
    );
  }

  renderContent = () => {
    let { navigation, route } = this.props;
    let {
      value,
      events,
      loadingEvents,
      valueAlt,
      loading,
      fetching,
      newProgressAt,
      newNote,
      error,
      scrollHeight,
      lines,
      pastRevisions,
      futureRevisions,
      offset,
      layoutComplete,
      bulkSelectIds,
      otherIsDragging,
      shelvedValues,
      draggingValue,
      overlappedValue,
      draggingRow,
      showTimeline,
      listView,
      explorerView,
      exploreAnim,
      exploreScale,
      exploreProgress,
      activeKeyView,
      revising,
      revision,
      childrenLayout,
      sortChildrenBy,
    } = this.state;
    if (revising) childrenLayout = "lists";

    if (!value) return <ActivityIndicator />;

    let pensieveLayout = this.context.pensieve && !revising;
    // let pensieveLayout = value.cycle === 0;

    return (
      <ScrollView
        // ref={(ref) => (this.scrollerRef = ref)}
        // flexGrow (not flex): flex pins the content to the viewport height,
        // which made anything taller (the Narrative section) unscrollable
        contentContainerStyle={[{ flexGrow: 1 }]}
        style={[
          {
            flex: 1,
          },
          !layoutComplete && { opacity: 0 },
        ]}
        onContentSizeChange={(width, height) => {
          let scrollHeight = height;
          this.setState({ scrollHeight });
        }}
        onScroll={(event) => {
          let scrollPos = event.nativeEvent.contentOffset.y;
          this.setState({ scrollPos });
        }}
        scrollEventThrottle={16}
        contentOffset={{ y: this.state.scrollPos }}
        scrollEnabled={!otherIsDragging}
      >
        <Animated.View
          style={[
            this.styles().section,
            !layoutComplete && { opacity: 0 },
            draggingRow == "parents" && { zIndex: 99 },
          ]}
        >
          {this.renderParents(value)}
        </Animated.View>

        {this.renderReferencers()}
        {this.renderRevisions()}

        {pensieveLayout && this.renderPensieveValue()}

        {!pensieveLayout && (
          <View
            style={[
              this.styles().section,
              { zIndex: 1 },
              draggingRow == "main" && { zIndex: 99 },
              explorerView && !layoutComplete && { opacity: 0 },
              // { borderWidth: 4, borderColor: "red" },
            ]}
          >
            <View
              style={[
                this.styles().contentRow,
                { minHeight: 0, marginHorizontal: 0 },
              ]}
            >
              <View style={[this.styles().row]}>
                {this.renderPastRevisions()}

                <View
                  style={{
                    flex: 1,
                    alignItems: "center",
                    zIndex: 1,
                    minWidth: 110,
                  }}
                >
                  {!value.id ? (
                    <ActivityIndicator />
                  ) : (
                    <Animated.View
                      style={[
                        {
                          alignItems: "center",
                          alignSelf: "stretch",
                        },
                        // {borderWidth: 1, borderColor: 'white',},
                      ]}
                      ref={(ref) => (this.valueRef = ref)}
                      onLayout={({ nativeEvent }) => {
                        setTimeout(() => {
                          if (this.valueRef) {
                            this.valueRef.measure(
                              (x, y, width, height, pageX, pageY) => {
                                // console.warn(`value layout - py:${pageY}`);
                                let offset = pageY + height / 2;
                                // console.warn(`scroll to ${offset}`)
                                // if(this.scrollerRef) this.scrollerRef.scrollTo({y: offset, animated: false})
                                if (!this.context.pensieve) {
                                  setTimeout(() => {
                                    // this.setState({ layoutComplete: true });
                                  }, 0);
                                }
                              },
                            );
                          }
                          // else alert(`no value ref`);
                        }, 0);
                      }}
                    >
                      <Draggable
                        onDragStart={() => {
                          this.setState({ draggingValue: value });
                        }}
                        onDragMove={(coords) => {
                          this.handleDragMove(coords);
                        }}
                        onDragEnd={(coords) => {
                          this.handleDragEnd(coords);
                        }}
                        freezeOnRelease={!!overlappedValue}
                        shelfThreshold={this.state.shelfThreshold}
                        onShelf={() => this.handleShelf(value)}
                      >
                        {(isDragging) => {
                          let textIcon =
                            value.id == draggingValue?.id &&
                            draggableHelpers.determineTextIcon(
                              draggingValue,
                              overlappedValue,
                            );
                          let size = 170;
                          let scale = null;
                          // if(!!textIcon) size *= 0.66
                          // else if(overlappedValue?.id == value.id) size *= 1.1
                          if (!!textIcon) scale = 0.66;
                          else if (overlappedValue?.id == value.id) scale = 1.1;
                          return (
                            <Value
                              // central value
                              key={revision?.id || value.id}
                              value={revising ? revision : value}
                              backgroundOpacity={revising ? 0.5 : undefined}
                              editing={revising}
                              placeholder={revising ? value.title : "Title..."}
                              editingText={revision.title}
                              onChangeText={(title) =>
                                this.setState({
                                  revision: { ...revision, title },
                                })
                              }
                              size={this.SIZE}
                              textIcon={textIcon}
                              size={size}
                              scale={scale}
                              onPress={() => {
                                if (isDragging) return null;
                                this.toggleTimeline(value);
                              }}
                              ref={(ref) => {
                                this[`val_${value.id}`] = ref;
                              }}
                              onUpdate={this.handleUpdate}
                              onLongPress={
                                revising
                                  ? (v) => {
                                      this.setState({
                                        revision: {
                                          ...revision,
                                          title: value.title,
                                        },
                                      });
                                    }
                                  : undefined
                              }
                              onLongPressAdditionally={(v) =>
                                this.setState({ bulkSelectIds: [v.id] })
                              }
                              focusIds={bulkSelectIds}
                              showFocusRing
                              coloredNotches
                              // childrenRing
                            />
                          );
                        }}
                      </Draggable>

                      {value.viewTimeline &&
                        !!value.timeline &&
                        value.timeline.length > 0 && (
                          <View style={{ flex: 0 }}>
                            {/*<ScrollView style={[this.styles().timeline, {borderColor: 'yellow', borderWidth: 1,}]} contentContainerStyle={[this.styles().timelineContentRow]}>*/}
                            <View
                              style={[
                                this.styles().timeline,
                                this.styles().timelineContentRow,
                              ]}
                            >
                              <View style={{ flex: 0 }}>
                                <Text style={this.styles().title}>
                                  Timeline:
                                </Text>
                                <TouchableOpacity
                                  onPress={() => this.addNewProgress()}
                                  style={{ alignSelf: "flex-end" }}
                                >
                                  <Ionicons
                                    name={"md-add"}
                                    color={this.context.colors.foreground}
                                    style={styleSheet.icon}
                                  />
                                </TouchableOpacity>
                              </View>

                              {newProgressAt != null && (
                                <View
                                  style={[
                                    this.styles().datePickerWrapper,
                                    { zIndex: 1 },
                                  ]}
                                >
                                  {/*<TextInput value={newProgressAt} onChangeText={newProgressAt => this.setState({newProgressAt})} style={this.styles().input} />*/}
                                  <DatePicker
                                    selected={new Date(newProgressAt)}
                                    // value={new Date(newProgressAt)}
                                    value={newProgressAt}
                                    onChange={(newProgressAt) =>
                                      this.setState({ newProgressAt })
                                    }
                                    inputStyle={this.styles().input}
                                    showTimeSelect
                                    // dateFormat="Pp"
                                  />

                                  <TextInput
                                    value={newNote}
                                    onChangeText={(newNote) =>
                                      this.setState({ newNote })
                                    }
                                    placeholder={"add note..."}
                                    placeholderTextColor={
                                      this.context.colors.placeholder
                                    }
                                    multiline
                                    style={[
                                      this.styles().input,
                                      this.styles().multilineInput,
                                    ]}
                                  />

                                  <View
                                    style={{
                                      flexDirection: "row",
                                      flexWrap: "nowrap",
                                    }}
                                  >
                                    <TouchableOpacity
                                      onPress={() =>
                                        this.setState({
                                          newProgressAt: null,
                                          newNote: "",
                                        })
                                      }
                                    >
                                      {/*<TouchableOpacity onPress={() => this.setState({newProgressAt: null})} hitSlop={5}>*/}
                                      <Ionicons
                                        name={"md-close"}
                                        color={this.context.colors.foreground}
                                        style={styleSheet.icon}
                                      />
                                    </TouchableOpacity>
                                    <TouchableOpacity
                                      onPress={() => this.saveCheck()}
                                    >
                                      {/*<TouchableOpacity onPress={this.saveCheck} hitSlop={5}>*/}
                                      <Ionicons
                                        name={"md-checkmark"}
                                        color={this.context.colors.foreground}
                                        style={styleSheet.icon}
                                      />
                                    </TouchableOpacity>
                                  </View>
                                </View>
                              )}

                              <Timeline
                                value={value}
                                deleteDoneAt={this.deleteDoneAt}
                                wrapperStyle={{ maxWidth: 300 }}
                              />
                            </View>
                          </View>
                        )}
                    </Animated.View>
                  )}
                </View>

                {this.renderFutureRevisions()}

                {/*<TouchableOpacity onPress={() => navigation.navigate('Create', {parent_ids: value.parent_ids})}>
                    <Ionicons name="ios-add-circle-outline" color={this.context.colors.foreground} style={styleSheet.icon} />
                  </TouchableOpacity>*/}
              </View>

              {false && showTimeline && (
                <TimelineNodes
                  value={value}
                  size={this.SIZE * CHILD_RATIO * 0.66}
                  size={this.SIZE * CHILD_RATIO * 0.85}
                  hoverScaleFactor={1.2}
                  onProgress={this.saveCheck}
                  onCreateChild={this.createChild}
                  onUpdate={this.handleUpdate}
                  deleteDoneAt={this.deleteDoneAt}
                  onDragStart={(draggingValue) => {
                    this.setState({
                      otherIsDragging: true,
                      draggingValue,
                      draggingRow: "main",
                    });
                  }}
                  onDragEnd={this.handleDragEnd}
                  onDragMove={this.handleDragMove}
                  draggingValue={draggingValue}
                  overlappedValue={overlappedValue}
                  freezeOnRelease={!!overlappedValue}
                  // wrapperStyle={{...this.styles().row, alignSelf: 'center'}}
                  shelfThreshold={this.state.shelfThreshold}
                  onShelf={this.handleShelf}
                  setValueRef={(ref, key) => {
                    this[key] = ref;
                  }}
                />
              )}
            </View>
          </View>
        )}

        {!this.context.pensieve && (
          <View
            style={{
              alignItems: "flex-end",
              marginRight: this.context.sizes.base,
            }}
          >
            <View
              style={{
                flexDirection: "row",
              }}
            >
              <Text
                // button
                // selectedButton={childrenLayout == "lists"}
                trim={childrenLayout != "lists"}
                onPress={
                  childrenLayout == "lists"
                    ? null
                    : () => {
                        this.setState({ childrenLayout: "lists" });
                        this.context.toggleListLayout();
                      }
                }
              >
                List
              </Text>
              <Text trim> | </Text>
              <Text
                // button
                // selectedButton={childrenLayout == "objects"}
                trim={childrenLayout != "objects"}
                onPress={
                  childrenLayout == "objects"
                    ? null
                    : () => {
                        this.setState({ childrenLayout: "objects" });
                        this.context.toggleListLayout();
                      }
                }
              >
                Items
              </Text>
            </View>
            {/*<View
            style={{
              flexDirection: "row",
            }}
          >
            <Text trim onPress={this.rotateSortChildrenBy}>
              Sort by: {sortChildrenBy}
            </Text>
          </View>*/}
          </View>
        )}
        {!!this.state.showReferences && this.renderReferences()}
        {pensieveLayout && this.renderScratchPad()}
        {childrenLayout == "lists" && this.renderColumns()}
        {childrenLayout == "objects" && this.renderChildren(value)}

        <View
          style={[
            this.styles().section,
            { justifyContent: showTimeline ? "flex-start" : "center" },
            !layoutComplete && { opacity: 0 },
            draggingRow == "children" && { zIndex: 99 },
            // minHeight (not a fixed height) in BOTH modes: the graph +
            // timeline flow naturally so the page's scroll range always
            // reaches the bottom of the strip
            { minHeight: 300 },
          ]}
        >
          {showTimeline ? (
            loadingEvents ? (
              <ActivityIndicator />
            ) : (
              <View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <ButtonGroup
                    options={[
                      { text: "Moments", value: "moments" },
                      { text: "Narrative", value: "narrative" },
                    ]}
                    selected={this.state.graphMode}
                    onSelect={(graphMode) => this.setState({ graphMode })}
                  />
                </View>
                {this.state.graphMode == "narrative" ? (
                  <JourneyMap
                    value={value}
                    onUpdateJourney={(journey) =>
                      this.setState({
                        value: { ...this.state.value, journey },
                      })
                    }
                  />
                ) : (
                  <AreaGraph data={[{ value, moments: events }]} />
                )}
                <MomentTimeline_Slats
                  value={value}
                  // events={events}
                  allRevisions={
                    !this.state.hideRevisions && !this.state.revisionsLoading
                  }
                  onHide={() => this.setState({ showTimeline: false })}
                  setEvents={(events) => this.setState({ events })}
                />
              </View>
            )
          ) : (
            <View style={{ alignSelf: "center" }}>
              <Text
                button
                onPress={() => this.setState({ showTimeline: true })}
              >
                Show Timeline
              </Text>
            </View>
          )}
        </View>
      </ScrollView>
    );
    {
      /*</Animated.View>
      </Animated.View>*/
    }
  };

  renderPensieveValue = () => {
    let { value, layoutComplete, showReferences, color, showHistory } =
      this.state;
    let foreground = this.context.colors.lightForeground;
    {
    }
    return (
      <Hoverable>
        {(isHovered) => (
          <View
            ref={(r) => (this.pensieveRef = r)}
            onLayout={({ nativeEvent }) => {
              console.log(
                "---on layout",
                !!this.pensieveRef,
                this.state.layoutComplete,
              );
              setTimeout(() => {
                if (!!this.pensieveRef && !this.state.layoutComplete) {
                  this.scrollToHeader(false);
                }
                // this.setState({ layoutComplete: true });
              }, 0);
            }}
            style={[
              !layoutComplete && { opacity: 0 },
              {
                flexDirection: "column",
                alignItems: "stretch",
                marginVertical: this.context.sizes.large,
                backgroundColor: color,
                padding: this.context.sizes.large,
              },
            ]}
          >
            <TouchableWithoutFeedback onPress={() => this.scrollToHeader()}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <HoverableTooltip
                  text={showHistory ? "Hide History" : "Show History"}
                  rightInline
                >
                  <MaterialIcons
                    name={"history"}
                    onPress={() => {
                      if (!showHistory) this.fetchHistory();
                      this.setState({ showHistory: !showHistory });
                    }}
                    color={foreground}
                    style={this.styles().icon}
                  />
                </HoverableTooltip>

                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  {!this.state.showTitleMoment && (
                    <View
                      style={[
                        this.styles().headerIconWrapper,
                        {
                          borderWidth: value?.completed_at ? 3 : 0,
                          borderColor: foreground,
                        },
                      ]}
                    >
                      <Icon
                        color={foreground}
                        size={this.context.sizes.giant}
                        name={valueHelpers.getIcon(value)}
                      />
                    </View>
                  )}

                  {this.state.showTitleMoment ? (
                    <MomentBullet
                      moment={{ value }}
                      onEscape={() => this.setState({ showTitleMoment: false })}
                    />
                  ) : !this.state.editingTitle ? (
                    <Text
                      bold
                      style={{
                        color: foreground,
                        fontSize: this.context.sizes.large,
                      }}
                      strike={!!value.completed_at}
                      color={foreground}
                      numberOfLines={1}
                      onPress={() => this.setState({ editingTitle: true })}
                      onLongPress={() =>
                        this.setState({ showTitleMoment: true })
                      }
                    >
                      {valueHelpers.filterRichText(
                        value.title || value.text,
                        value,
                      )}
                    </Text>
                  ) : (
                    <TextInput
                      style={{
                        fontWeight: "bold",
                        color: foreground,
                        fontSize: this.context.sizes.large,
                      }}
                      placeholder={"Title"}
                      placeholderTextColor={foreground}
                      value={this.state.title || ""}
                      onChangeText={(title) => this.setState({ title })}
                      onLongPress={() =>
                        this.setState({ showTitleMoment: true })
                      }
                      autoFocus
                      onBlur={() => {
                        this.setState({ editingTitle: false });
                        // if (!!this.state.title)
                        valueActions.update(value.id, {
                          title: this.state.title,
                        });
                      }}
                    />
                  )}
                </View>

                <AntDesign
                  name={"edit"}
                  onPress={() => RootNavigation.push("Edit", { id: value.id })}
                  color={foreground}
                  style={this.styles().icon}
                />
              </View>
            </TouchableWithoutFeedback>

            {isHovered && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-around",
                  position: "absolute",
                  left: this.context.sizes.base,
                  right: this.context.sizes.base,
                  bottom: this.context.sizes.small,
                }}
              >
                <Text
                  light
                  underline
                  onPress={() =>
                    this.setState({
                      showReferences:
                        showReferences == "references_to"
                          ? ""
                          : "references_to",
                    })
                  }
                >
                  References to
                </Text>
                <Text
                  light
                  underline
                  onPress={() =>
                    this.setState({
                      showReferences:
                        showReferences == "referenced_by"
                          ? ""
                          : "referenced_by",
                    })
                  }
                >
                  Referenced by
                </Text>
                <Text
                  light
                  underline
                  onPress={() =>
                    this.setState({
                      showReferences:
                        showReferences == "suggestions_to"
                          ? ""
                          : "suggestions_to",
                    })
                  }
                >
                  Suggested references to
                </Text>
                <Text
                  light
                  underline
                  onPress={() =>
                    this.setState({
                      showReferences:
                        showReferences == "suggestions_by"
                          ? ""
                          : "suggestions_by",
                    })
                  }
                >
                  Suggested referenced by
                </Text>
              </View>
            )}

            {value.cycle != 0 && (
              <View
                style={{
                  position: "absolute",
                  left: this.context.sizes.base,
                  right: this.context.sizes.base,
                  bottom: this.context.sizes.tiny,
                  borderRadius: 10,
                  flexDirection: "row",
                  alignItems: "flex-end",
                  overflow: "hidden",
                  // backgroundColor: valueHelpers.iconColor(
                  //   value,
                  //   color,
                  //   this.context.colorScheme
                  // ).color,
                  // padding: 1,
                }}
              >
                <ProgressBar
                  value={value}
                  gapless
                  // color={color}
                  // backgroundColor={colorHelpers.hexToRgbaString(color, 0.4)}
                  backgroundColor={colorHelpers.hexToRgbaString(
                    this.context.colors.darkForeground,
                    0.15,
                  )}
                  color={
                    valueHelpers.iconColor(
                      value,
                      color,
                      this.context.colorScheme,
                    ).color
                  }
                />
              </View>
            )}
          </View>
        )}
      </Hoverable>
    );
  };

  handleDragEnd = async (coords) => {
    const draggingValue = this.state.draggingValue;
    let overlappedValue = await this.checkOverlap(coords, draggingValue);
    if (!!overlappedValue) {
      // this.handleRelease(draggingValue, overlappedValue)
      let updatedValue = await draggableHelpers.handleRelease(
        draggingValue,
        overlappedValue,
      );
      if (!!updatedValue) {
        this.handleUnshelf(draggingValue);
      }
    } else {
      let reorderedParentIds = await this.checkReorderedParents(
        coords,
        draggingValue,
      );
      if (!!reorderedParentIds) {
        // console.log('pref order:', this.state.value.parent_ids)
        // console.log('new order:', reorderedParentIds)
        valueActions.update(this.state.value.id, {
          parent_ids: reorderedParentIds,
        });
      }
    }
    this.setState({
      otherIsDragging: false,
      draggingRow: null,
      draggingValue: null,
      overlappedValue: null,
    });
  };

  handleDragMove = async (coords) => {
    let overlappedValue = await this.checkOverlap(
      coords,
      this.state.draggingValue,
    );
    // if(!!overlappedValue) console.log(overlappedValue)
    if (
      !!overlappedValue &&
      overlappedValue.id != this.state.overlappedValue?.id
    ) {
      this.setState({ overlappedValue });
    } else if (!overlappedValue && !!this.state.overlappedValue) {
      this.setState({ overlappedValue: null });
    }
  };

  checkOverlap = async (coords, draggingValue) => {
    let { value, family, futureRevisions, pastRevisions } = this.state;
    let overlappedValue = null;

    let valuesToCheck = [...futureRevisions, ...family, ...pastRevisions];

    // for(let val of family){
    for (let val of valuesToCheck) {
      if (draggingValue?.id == val.id) continue;

      // console.log(`checking: ${val.id}`)

      let ref = this[`val_${val.id}`];
      let inspect = val.id == 447;
      if (draggableHelpers.checkOverlap(coords, ref, inspect)) {
        overlappedValue = val;
        break;
      }

      let nodeRef = this[`val_node_${val.id}`];
      if (draggableHelpers.checkOverlap(coords, nodeRef)) {
        overlappedValue = val;
        break;
      }

      let shelfRef = this[`val_shelf_${val.id}`];
      if (draggableHelpers.checkOverlap(coords, shelfRef)) {
        overlappedValue = val;
        break;
      }
    }
    return overlappedValue;
  };

  checkReorderedParents = async (coords, draggingValue) => {
    let { value, family } = this.state;
    let overlappedValue = null;
    if (value.parent_ids.includes(draggingValue.id)) {
      let refObjs = value.parent_ids
        .map((parentId) => {
          console.log("parentId", parentId);
          if (parentId == draggingValue.id) return null;
          return {
            id: parentId,
            ref: this[`val_${parentId}`],
          };
        })
        .filter((x) => !!x);

      let orderedIds = draggableHelpers.checkOrder(
        coords,
        refObjs,
        draggingValue.id,
      );

      if (!orderedIds?.length) return null;
      else if (JSON.stringify(value.parent_ids) == JSON.stringify(orderedIds))
        return null;
      else return orderedIds;
    }
    return null;
  };

  toggleTimeline = (v) => {
    this.setState({ showTimeline: !this.state.showTimeline });
  };

  renderReferencers = () => {
    let { referencers } = this.state;
    if (!referencers?.length) return null;
    return this.renderValueRow("Referenced by", referencers);
  };

  renderRevisions = () => {
    let { value, revisions, revisionsLoading } = this.state;
    if (value.id == value.root_id) return null;
    else if (
      !!value.revision_ids?.length &&
      !revisions.length &&
      !revisionsLoading
    ) {
      this.fetchRevisions();
    }
    if (!revisions?.length) return null;
    return this.renderValueRow("Versions", revisions, "Show all", () =>
      this.setState({ showAllRevisions: true }),
    );
  };

  renderValueRow = (
    title = "",
    values = [],
    tooltipText = "",
    onPressTitle = null,
  ) => {
    return (
      <View
        style={{
          flexDirection: "row",
          paddingHorizontal: this.context.sizes.large,
        }}
      >
        {!!tooltipText?.length ? (
          <HoverableTooltip text={tooltipText} rightInline>
            <Text onPress={onPressTitle}>{title}: </Text>
          </HoverableTooltip>
        ) : (
          <Text onPress={onPressTitle}>{title}: </Text>
        )}
        <ScrollView
          horizontal
          style={{ flex: 1 }}
          contentContainerStyle={[
            // this.styles().generationRow,
            {
              // justifyContent: "flex-start",
              alignItems: "center",
            },
          ]}
        >
          {values.map((value, i) => {
            let color = valueHelpers.getColor(
              value,
              this.context.colorScheme,
              this.context.colors.foreground,
            );
            return (
              <Tag
                key={i}
                icon
                value={value}
                onPress={(e) =>
                  RootNavigation.push("Project", { id: value.id }, e)
                }
              />
            );
            return (
              <TouchableOpacity
                key={i}
                onPress={(e) =>
                  RootNavigation.push("Project", { id: value.id }, e)
                }
                style={{ marginRight: this.context.sizes.small }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    maxWidth: 200,
                    borderRadius: this.context.sizes.smallBorderRadius,
                    padding: this.context.sizes.tiny,
                    paddingHorizontal: this.context.sizes.base,
                    backgroundColor: colorHelpers.hexToRgbaString(color, 0.2),
                  }}
                >
                  {!!value.icon && (
                    <Icon
                      name={value.icon}
                      color={color}
                      size={this.context.sizes.default}
                      style={{ marginRight: this.context.sizes.small }}
                    />
                  )}
                  <Text numberOfLines={1} style={{ color }}>
                    {valueHelpers.filterRichText(
                      value.title || value.text,
                      value,
                    )}
                  </Text>
                </View>
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      </View>
    );
  };

  renderParents = (value) => {
    let { revising, revision } = this.state;
    return (
      <View style={[this.styles().contentRow, { alignItems: "flex-end" }]}>
        <View horizontal style={[this.styles().generationRow]}>
          <View style={{ flex: 0.5 }} />
          <Generation
            value={value}
            ids={value.parent_ids}
            name={"parents"}
            level={1}
          />
          <View style={{ flex: 0.5 }} />
        </View>
        {revising && (
          <View
            style={[
              this.styles().generationRow,
              { top: "80%", position: "absolute" },
            ]}
          >
            {value.parent_ids.map((id, i) => {
              let selected = revision.parent_ids.includes(id);
              let backgroundColor = this.context.colors.foreground;
              return (
                <Badge
                  key={i}
                  // chapter={chapter}
                  noTooltip
                  checkIcon
                  iconColor={
                    selected ? backgroundColor : this.context.colors.empty
                  }
                  ringColor={
                    selected ? backgroundColor : this.context.colors.trim
                  }
                  backgroundColor={this.context.colors.empty}
                  moment={{ value: {} }}
                  onPress={() => this.toggleRevisingParentId(id)}
                  large
                  // scale={this.props.badgeScale}
                  mobileLarge
                />
              );
            })}
          </View>
        )}
      </View>
    );
  };

  renderChildren = (value) => {
    let { showNotes, hasNotes } = this.state;
    return (
      <View
        style={[
          this.styles().contentRow,
          { alignItems: "flex-start" },
          !this.state.layoutComplete && { opacity: 0 },
        ]}
      >
        {/*showNotes && <Text>notes here</Text>*/}
        <View style={[this.styles().generationRow]}>
          {/*<View style={{ flex: 0.5 }} />*/}
          <Generation
            value={value}
            ids={value.child_ids}
            name={"children"}
            level={-1}
            includeNotes={showNotes}
            setShowNotes={(x) => this.setState({ showNotes: x })}
            setHasNotes={(x) => this.setState({ hasNotes: x })}
            button={
              !showNotes &&
              hasNotes && (
                <HoverableTooltip text="Show Notes">
                  <FontAwesome
                    name={"file-text-o"}
                    color={this.context.colors.trim}
                    size={this.context.sizes.large}
                    onPress={() => this.setState({ showNotes: true })}
                  />
                </HoverableTooltip>
              )
            }
          />
          {/*<View style={{ flex: 0.5 }} />*/}
        </View>
      </View>
    );
  };

  renderColumns = () => {
    let { value, revising, subtasks, showSubtasks, color } = this.state;
    let { showValueNotes, showColumns, showCanvas, showMomentList } =
      this.state;
    let columns = ["active", "ongoing", "complete", "inactive"];

    // let children = valueHelpers.getChildren({ value, sort: "inherited" });
    let children = valueHelpers.getChildren({ value });
    let active = children.filter(
      (c) => !c.completed_at && !c.archived_at, // && !c.snooze_until && c.cycle !== 0
    );
    let complete = children.filter((c) => !!c.completed_at || !!c.archived_at);
    // let ongoing = children.filter(
    //   (c) =>
    //     c.cycle === 0 && !c.completed_at && !c.snooze_until && !c.archived_at
    // );
    let ongoing = [];
    let inactive = children.filter(
      (c) => !c.completed_at && (!!c.snooze_until || !!c.archived_at),
    );

    if (!ongoing.length) columns.splice(columns.indexOf("ongoing"), 1);
    if (!inactive.length) columns.splice(columns.indexOf("inactive"), 1);

    if (value.id == "journal") {
      return <View>{this.renderNotes()}</View>;
    }

    return (
      <View
        style={[
          !this.state.layoutComplete && { opacity: 0 },
          {
            // borderWidth: 4,
            // borderColor: "purple",
            // alignSelf: "stretch",
            // alignItems: "center",
          },
        ]}
      >
        {revising && !!value.child_ids?.length && (
          <View
            style={{
              alignSelf: "center",
              padding: this.context.sizes.base,
              marginBottom: this.context.sizes.large,
            }}
          >
            <Text bold>Select children to carry over</Text>
          </View>
        )}

        <View
          style={{
            flexDirection: "row",
            margin: this.context.sizes.base,
            marginTop: 0,
            justifyContent: "flex-end",
            alignItems: "center",
            zIndex: 2,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginRight: this.context.sizes.base,
            }}
          >
            <Text>Actions: </Text>
            {/*
            <HoverableTooltip text="Copy all child nodes into scratchpad">
              <Text smallButton onPress={() => alert("wip")}>
                Transcribe
              </Text>
            </HoverableTooltip>
            */}
            <MultiButton
              tooltipText="Copy open child nodes into scratchpad"
              small
              text="Transcribe"
              action={() => alert("wip")}
              options={[
                {
                  text: "Transcribe all",
                  action: () => alert("1"),
                },
                {
                  text: "Transcribe open notes",
                  action: () => alert("2"),
                },
                {
                  text: "Transcribe open values",
                  action: () => alert("3"),
                },
                {
                  text: "Transcribe completed",
                  action: () => alert("4"),
                },
              ]}
            />
          </View>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text>Views: </Text>
            <Text
              smallButton
              selectedButton={showValueNotes}
              onPress={() => this.setState({ showValueNotes: !showValueNotes })}
            >
              Blocks
            </Text>
            <Text
              smallButton
              selectedButton={showColumns}
              onPress={() => this.setState({ showColumns: !showColumns })}
            >
              Columns
            </Text>
            <Text
              smallButton
              selectedButton={showMomentList}
              onPress={() => this.setState({ showMomentList: !showMomentList })}
            >
              List
            </Text>
            <Text
              smallButton
              selectedButton={showCanvas}
              onPress={() => this.setState({ showCanvas: !showCanvas })}
            >
              Canvas
            </Text>
          </View>
        </View>

        {this.context.pensieve && this.renderPensieveNotes()}

        {showCanvas && (
          <View style={{ margin: this.context.sizes.default }}>
            <Text bold>Canvas</Text>
            <View
              style={{
                flexDirection: "row",
                marginTop: this.context.sizes.small,
              }}
            >
              <Text button smallButton onPress={() => alert("Change Image")}>
                Change Image
              </Text>
            </View>
            <View
              style={{
                minHeight: 300,
                alignItems: "center",
                marginVertical: this.context.sizes.default,
                padding: this.context.sizes.default,
                backgroundColor: this.context.colors.fill,
              }}
            >
              <Image
                source={require("root/assets/images/canvas/wireframe_man.png")}
                style={{ height: 500, width: 500 }}
                resizeMode={"contain"}
              />
            </View>
          </View>
        )}

        {showColumns && (
          <ScrollView
            horizontal
            style={
              {
                // borderWidth: 8,
                // borderColor: "red",
                // flex: 1,
              }
            }
            contentContainerStyle={[
              this.styles().sectionsRow,
              // { borderWidth: 4, borderColor: "green" },
            ]}
          >
            {/*this.context.pensieve && this.renderPensieveNotes()*/}
            {showSubtasks ? (
              this.renderChildrenList({
                values: subtasks,
                status: "subtasks",
                children: subtasks,
                columns,
              })
            ) : (
              <View style={{ marginLeft: this.context.sizes.default }}>
                <Text button onPress={this.fetchSubtasks}>
                  Subtasks
                </Text>
              </View>
            )}
            {this.renderChildrenList({
              values: active,
              children,
              status: "active",
              columns,
            })}
            {!!ongoing.length &&
              this.renderChildrenList({
                values: ongoing,
                children,
                status: "ongoing",
                columns,
              })}
            {this.renderNotes()}
            {this.renderChildrenList({
              values: complete,
              children,
              status: "complete",
              columns,
            })}
            {!!inactive.length &&
              this.renderChildrenList({
                values: inactive,
                children,
                status: "inactive",
                columns,
              })}
            <View>
              <Text button onPress={() => null}>
                Expand All
              </Text>
            </View>
          </ScrollView>
        )}

        {showMomentList && (
          <View
            style={{
              marginLeft: this.context.sizes.largeBulletWidth / 2,
              borderLeftWidth: 2,
              // borderColor: colorHelpers.hexToRgbaString(color, 0.6),
              borderColor: color,
              paddingLeft: this.context.sizes.default,
              alignItems: "center",
            }}
          >
            <View style={{ minWidth: 600 }}>
              <MomentList
                moment={{ value }}
                ref={(ref) => (this.momentList = ref)}
                moments={valueHelpers
                  .getChildren({ value, includeNotes: true })
                  .map((v) => ({ value: v, id: `child-${v.id}` }))}
                // pinnedMomentList={pinnedMomentList}
                // chapterMoments={chapterMoments}
                // progress_at={value.progress_at}
                value={value}
                parentIsValue
                parentId={value.id}
                focusParentMoment={() => this.scratPadRef?.focus()}
                // hideScrathpadPreview={this.props.hideScrathpadPreview}
                // nestedChildrenView={!expanded}
                // horizontal={horizontal}
                // hideTags={this.props.hideTags}
                // hideBadgeRow={this.props.hideBadgeRow}
                // expanded={this.props.expanded && this.props.recursiveExpanded}
                // parentExpanded={expanded}
                // parentFocused={focused}
                // preventAutoFocus={this.props.preventAutoFocus}
                // valueBadges={this.props.valueBadge}
                // collapseParent={() => this.toggleExpanded(false)}
                // onFocusChapterTitle={this.props.focusParentMoment}
                // onFocusNextChapter={this.props.onFocusNextChapter}
                // onFocusPreviousChapter={this.props.onFocusPreviousChapter}
                // onExpandMoment={this.props.onExpand}
                // onCollapseMoment={this.props.onCollapse}
              />
            </View>
          </View>
        )}
      </View>
    );
  };

  renderChildrenList = ({ values, status, columns, children = [] }) => {
    let { value, revising, revision, subtasksLoading } = this.state;
    let moments = values.map((v) => ({ value: v, id: `child-${v.id}` }));
    let chapterMoments = children.map((v) => ({
      value: v,
      id: `child-${v.id}`,
    }));
    if (revising) {
      // moments = moments.map((x) => ({ ...x, completed_at: new Date() }));
    }
    // let disabled = revising && ["complete", "inactive"].includes(status);
    let dimmed = revising && ["complete", "inactive"].includes(status);

    let createWithParams = {};
    if (status == "complete") createWithParams = { completed_at: new Date() };
    else if (status == "inactive")
      createWithParams = { archived_at: new Date() };
    else if (status == "ongoing") createWithParams = { cycle: 0 };
    return (
      <View
        style={[this.styles().sectionCol, dimmed && { opacity: 0.3 }]}
        // pointerEvents={disabled ? "none" : undefined}
      >
        <Text
          bold
          underline
          style={{
            marginLeft:
              this.context.sizes.bulletWidth + this.context.sizes.small,
          }}
        >
          {textHelpers.humanize(status)}
        </Text>
        <ScrollView
          // horizontal
          style={{ paddingLeft: this.context.sizes.small }}
        >
          {status == "subtasks" && subtasksLoading && <ActivityIndicator />}
          <MomentList
            ref={(ref) => (this[`col-${status}`] = ref)}
            moments={moments}
            chapterMoments={chapterMoments}
            createWithParams={createWithParams}
            chapter={{ id: `value-${value.id}` }}
            rootChapter={{ id: `value-${value.id}`, is_value: true }}
            selectable={revising}
            selectedIds={revision.child_ids}
            onSelectValue={(id) => this.toggleRevisingChildId(id)}
            preventAutoFocus
            parentIsValue
            parentId={value.id}
            onFocusNextChapter={() => {
              let myIndex = columns.indexOf(status);
              let nextIndex = myIndex + 1;
              if (nextIndex <= columns.length - 1) {
                let targetColumn = columns[nextIndex];
                let ref = this[`col-${targetColumn}`];
                if (!!ref) {
                  !!ref.handleFocusComposer && ref.handleFocusComposer();
                }
              }
            }}
            onFocusPreviousChapter={() => {
              let myIndex = columns.indexOf(status);
              let prevIndex = myIndex - 1;
              if (prevIndex >= 0) {
                let targetColumn = columns[prevIndex];
                let ref = this[`col-${targetColumn}`];
                if (!!ref) {
                  !!ref.handleFocusComposer && ref.handleFocusComposer();
                }
              } else {
                let ref = this[`col-notes`];
                if (!!ref) {
                  !!ref.handleFocusComposer && ref.handleFocusComposer();
                }
              }
            }}
          />
          {/*children.map((child, i) => {
            return (
              <MomentBullet
                key={i}
                expanded={false}
                moment={{ value: child }}
              />
            );
          })*/}
          {/*<MomentComposer
            inputRef={(c) => (this[`ref-${status}-composer`] = c)}
            parentId={value.id}
            preventAutoFocus
          />*/}
        </ScrollView>
      </View>
    );
  };

  renderNotes = () => {
    let { value, sorting, revising, revision } = this.state;
    // let notes = valueHelpers.getNotes(value);
    let notes = valueHelpers.getChildren({
      value,
      // sort: "inherited",
      includeNotes: true,
    });
    // notes = textHelpers.newestFirst(notes, "created_at");
    // notes = notes.sort((a, b) => (!!a.completed_at && !b.completed_at ? 1 : 0));
    notes = notes.filter((c) => c.is_note);
    // if (revising) {
    //   notes = notes.map((x) => ({
    //     ...x,
    //     completed_at: new Date(),
    //     completed: true,
    //   }));
    // }
    // notes = textHelpers.newestFirst(notes, "updated_at");
    return (
      <View style={this.styles().sectionCol}>
        <View
          style={{
            alignSelf: "stretch",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Text
            bold
            underline
            style={{
              marginLeft:
                this.context.sizes.bulletWidth + this.context.sizes.small,
            }}
          >
            Notes
          </Text>
          <Text trim onPress={() => this.toggleSorting("notes")}>
            sort: {sorting.notes}
          </Text>
        </View>
        <ScrollView
          // horizontal
          style={{ flex: 1, paddingLeft: this.context.sizes.small }}
          contentContainerStyle={{
            // flex: 1,
            // borderWidth: 2,
            borderColor: "red",
          }}
        >
          <MomentList
            ref={(ref) => (this[`col-notes`] = ref)}
            preventAutoFocus
            parentIsValue
            parentId={value.id}
            rootChapter={{ id: `value-${value.id}`, is_value: true }}
            defaultToNote
            createWithParams={{ is_note: true }}
            moments={notes.map((note) => ({
              value: note,
              id: `note-${note.id}`,
            }))}
            disableSorting={sorting.notes !== "manual"}
            onFocusNextChapter={() => {
              let ref = this[`col-active`];
              if (!!ref) {
                !!ref.handleFocusComposer && ref.handleFocusComposer();
              }
            }}
            composerPlaceholder={revising ? "Final reflections..." : null}
            selectable={revising}
            selectedIds={revision.child_ids}
            onSelectValue={(id) => this.toggleRevisingChildId(id)}
            disableSuggestions={revising}
            onChangeText={
              revising
                ? (finalReflections) =>
                    this.setState({
                      revision: { ...revision, finalReflections },
                    })
                : undefined
            }
            onSubmit={revising ? () => this.handleRevise() : undefined}
          />
          {notes.map((note, i) => {
            return null;
            return (
              <View key={i}>
                <Text //bold button
                  trim
                  style={{ marginLeft: this.context.sizes.bulletWidth }}
                >
                  {textHelpers.formatDate(note.created_at, true, false)}
                </Text>
                <MomentBullet
                  key={i}
                  expanded={false}
                  // multiline
                  moment={{ value: note }}
                  style={{
                    maxHeight: 100,
                  }}
                  expandedStyle={{
                    minWidth: undefined,
                    maxWidth: 600,
                    width: 600,
                    maxHeight: HEIGHT - 300,
                    // backgroundColor: this.context.colors.fill,
                  }}
                />
              </View>
            );
          })}
          {false && (
            <MomentComposer
              inputRef={(c) => (this[`ref-note-composer`] = c)}
              parentId={value.id}
            />
          )}
        </ScrollView>
      </View>
    );
  };

  renderPensieveNotes = () => {
    let { value, showValueNotes } = this.state;
    if (!showValueNotes) return null;
    return <ValueNoteList value={value} />;
  };

  // today's day-moment for this value, if one exists — "Save as moment" in
  // the scratchpad targets it instead of creating a duplicate pin
  findPresentMoment = () => {
    let { moments, momentsChapters } = this.state;
    if (!moments?.length) return null;
    let todayStr = timeHelpers.dateTimeToDate(new Date());
    return moments.find((m) => {
      let ch = momentsChapters?.find((c) => c.id == m.chapter_id);
      return ch?.range == 1 && ch?.start_at == todayStr;
    });
  };

  renderScratchPad = () => {
    let { value, sorting, revising, revision } = this.state;
    let { loadingHistory, showHistory, moments, chapters } = this.state;
    if (showHistory) {
      // map through revisions too?
      return (
        <FlatList
          horizontal
          inverted
          style={{
            padding: this.context.sizes.base,
          }}
          data={[{ chapter: { start_at: "Current" } }, ...moments]}
          keyExtractor={(item) => `val=${item.id}`}
          renderItem={({ item, index }) => {
            let moment = item;
            // let val = moment?.snapshot ? JSON.parse(moment.snapshot) : value;
            let i = moments.length - index;

            let snapshot = null;
            let nextSnapshot = null;
            if (moment.snapshot) snapshot = JSON.parse(moment.snapshot);
            if (moment.next_snapshot)
              nextSnapshot = JSON.parse(moment.next_snapshot);
            let hasTitleChanges =
              !!snapshot?.title && snapshot?.title != nextSnapshot?.title;
            let hasTextChanges =
              !!snapshot?.text && snapshot?.text != nextSnapshot?.text;
            if (!hasTextChanges) {
              console.log("no text changes?", snapshot, nextSnapshot);
            }
            hasTextChanges = true;
            return (
              <View key={index} style={{ flexDirection: "row" }}>
                {index == 0 && loadingHistory && (
                  <View
                    style={{
                      width: this.context.sizes.WIDTH * (ENV.WEB ? 0.5 : 0.66),
                      marginRight: this.context.sizes.base,
                      alignItems: "center",
                    }}
                  >
                    <ActivityIndicator />
                  </View>
                )}
                <View
                  style={{
                    width: this.context.sizes.WIDTH * (ENV.WEB ? 0.5 : 0.66),
                    marginRight: this.context.sizes.base,
                  }}
                >
                  <Text>
                    {i}: {moment?.chapter?.start_at}
                  </Text>
                  {hasTitleChanges && <Text bold>{snapshot?.title}</Text>}
                  {hasTextChanges && (
                    <ScratchPad
                      // value={{ ...value, ...val }}
                      value={value}
                      moment={moment}
                      readOnly
                      ref={(r) => (this[`scratPadRef-${index}`] = r)}
                      focusNext={() => {
                        this.momentList?.handleFocusFirstMoment();
                      }}
                    />
                  )}
                </View>
              </View>
            );
          }}
        />
      );
      return (
        <ScrollView
          horizontal
          // inverted
          style={{
            padding: this.context.sizes.base,
            transform: [{ scaleX: -1 }],
          }}
        >
          <View
            style={{
              width: this.context.sizes.WIDTH * (ENV.WEB ? 0.5 : 0.66),
              transform: [{ scaleX: -1 }],
            }}
          >
            <Text>Current</Text>
            <ScratchPad
              value={value}
              ref={(r) => (this.scratPadRef = r)}
              focusNext={() => {
                this.momentList?.handleFocusFirstMoment();
              }}
            />
          </View>
          {loadingHistory ? (
            <View
              style={{
                width: this.context.sizes.WIDTH * (ENV.WEB ? 0.5 : 0.66),
              }}
            >
              <ActivityIndicator />
            </View>
          ) : (
            moments.map((moment, i) => {
              {
                /*if (!moment.next_snapshot?.length) return null;
              if (!moment.snapshot?.length) return null;
              let val = JSON.parse(moment.snapshot);
              if (!val) return null;*/
              }
              return (
                <View
                  key={i}
                  style={{
                    width: this.context.sizes.WIDTH * (ENV.WEB ? 0.5 : 0.66),
                    marginLeft: this.context.sizes.base,
                    transform: [{ scaleX: -1 }],
                  }}
                >
                  <Text>{moment?.chapter?.start_at}</Text>
                  <ScratchPad
                    key={i}
                    // value={{ ...value, ...val }}
                    value={value}
                    moment={moment}
                    // snapshot={JSON.parse(moment.snapshot)}
                    // nextSnapshot={JSON.parse(moment.next_snapshot)}
                    readOnly
                    ref={(r) => (this[`scratPadRef-${i}`] = r)}
                    focusNext={() => {
                      this.momentList?.handleFocusFirstMoment();
                    }}
                    maxWidth={this.context.sizes.WIDTH * (ENV.WEB ? 0.5 : 0.66)}
                  />
                </View>
              );
            })
          )}
        </ScrollView>
      );
    }
    return (
      <View
        style={[
          {
            flexDirection: "column",
            padding: this.context.sizes.base,
            paddingTop: 0,
            zIndex: 2,
          },
        ]}
      >
        {this.state.moments?.length > 0 &&
          (this.state.showMomentsLog ? (
            <View style={{ marginBottom: this.context.sizes.base }}>
              <MomentsLog
                value={value}
                moments={this.state.moments}
                chapters={this.state.momentsChapters}
                ref={(r) => (this.momentsLogRef = r)}
                focusNext={() => {
                  this.scratPadRef?.focus && this.scratPadRef.focus();
                }}
              />
            </View>
          ) : (
            <Text
              style={{
                alignSelf: "flex-end",
                color: this.context.colors.trim,
                marginBottom: this.context.sizes.base,
              }}
              onPress={() => this.setState({ showMomentsLog: true })}
            >
              Show moments
            </Text>
          ))}
        <ScratchPad
          value={value}
          presentMoment={this.findPresentMoment()}
          onRefreshChapter={this.fetch}
          ref={(r) => (this.scratPadRef = r)}
          focusNext={() => {
            this.momentList?.handleFocusFirstMoment();
          }}
          focusPrevious={() => {
            if (this.state.moments?.length > 0 && this.state.showMomentsLog) {
              this.momentsLogRef?.focus && this.momentsLogRef.focus();
            }
          }}
        />
      </View>
    );
  };

  renderReferences = () => {
    let { value, showReferences } = this.state;
    return (
      <ReferenceList
        value={value}
        type={showReferences}
        onClose={() => this.setState({ showReferences: "" })}
      />
    );
  };

  renderGeneration = ({
    val,
    key,
    level = 0,
    nextGen = null,
    nextGenOnly = false,
    collapsed = true,
  }) => {
    return null;
    // let condensedVal = valueHelpers.condenseRevisions(val);
    // return (
    //   <MomentBullet
    //     key={val.id}
    //     moment={{ value: condensedVal }}
    //     expanded={false}
    //     stackTags
    //   />
    // );
    let { navigation } = this.props;
    let {
      bulkSelectIds,
      draggingValue,
      overlappedValue,
      listView,
      explorerView,
    } = this.state;
    if (nextGen == null)
      nextGen =
        key == "parents"
          ? valueHelpers.getParents({ value: val, filterToActive: true })
          : valueHelpers.getChildren({ value: val, sort: true });
    return (
      <Generation
        key={`${val.id}-${level}`}
        nextGenOnly={nextGenOnly}
        value={val}
        size={
          key == "parents" ? this.SIZE * PARENT_RATIO : this.SIZE * CHILD_RATIO
        }
        draggingValue={draggingValue}
        overlappedValue={overlappedValue}
        setValueRef={(ref, key) => {
          this[key] = ref;
        }}
        nextGen={nextGen}
        // nextGen={[]}
        genKey={key}
        level={level}
        navigation={navigation}
        onUpdate={this.handleUpdate}
        // onPress={bulkSelectIds?.length ? this.toggleBulkSelection : undefined}
        focusIds={bulkSelectIds}
        showFocusRing
        onDragEnd={this.handleDragEnd}
        onDragMove={this.handleDragMove}
        freezeOnRelease={!!overlappedValue}
        onDragStart={(draggingValue) => {
          this.setState({
            otherIsDragging: true,
            draggingValue,
            draggingRow: key,
          });
        }}
        shelfThreshold={this.state.shelfThreshold}
        onShelf={this.handleShelf}
        onToss={this.handleToss}
        // style={{maxWidth: WIDTH/nextGen.length}}
        //style={{maxWidth: 500}}
        // style={!listView && {maxWidth: 200}}
        listView={listView}
        recurOnHover
      />
    );
  };

  toggleBulkSelection = (value) => {
    let { bulkSelectIds } = this.state;
    if (bulkSelectIds.includes(value.id)) {
      bulkSelectIds.splice(bulkSelectIds.indexOf(value.id), 1);
    } else {
      bulkSelectIds.push(value.id);
    }
    this.setState({ bulkSelectIds });
  };

  renderPastRevisions = () => {
    let { value, hideRevisions, revisionsLoading, revisions, revising } =
      this.state;
    if (value.id == "journal") return null;
    let revisionIds = [...(value.revision_ids || [])].filter(
      (id) => id != value.id,
    );
    if (revising) {
      revisionIds = textHelpers.uniq([...revisionIds, value.id]);
      revisions = textHelpers.uniq(
        [...revisions, { ...value, completed_at: new Date(), completed: true }],
        "id",
      );
    }
    let pastRevisionIds = revisionIds.filter((id) => id <= value.id);
    // if (!pastRevisionIds.length) return <View style={{ flex: 1 }} />;
    if (!revisionIds?.length) return <View style={{ flex: 1 }} />;
    else if (hideRevisions) {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
          }}
        >
          <TouchableOpacity
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "flex-end",
            }}
            onPress={this.fetchRevisions}
          >
            <HoverableTooltip text="View revisions" rightAligned={false}>
              <MaterialCommunityIcons
                name="history"
                size={40}
                color={this.context.colors.fill}
              />
            </HoverableTooltip>
          </TouchableOpacity>
        </View>
      );
      // } else if (revisionsLoading) {
      //   return (
      //     <View
      //       style={{ flex: 1, justifyContent: "center", alignItems: "flex-end" }}
      //     >
      //       <ActivityIndicator />
      //     </View>
      //   );
    } else
      return (
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {revisionsLoading ? (
            <ActivityIndicator />
          ) : (
            <Text
              button
              style={[ENV.WEB && { width: 50 }]}
              onPress={() => this.setState({ hideRevisions: true })}
            >
              X
            </Text>
          )}
          {!!revisions.length && (
            <FlatList
              horizontal
              style={{ opacity: 0.9 }}
              inverted
              data={revisions
                .filter((r) => pastRevisionIds.includes(r.id))
                .reverse()}
              keyExtractor={(item) => `val=${item.id}`}
              renderItem={({ item, index }) => {
                // past revisions
                let v = item;
                let length = 3;
                let i = length - index;
                let scaleFactor = Math.max(0, 0.3 * (i / length));
                scaleFactor += 0.5;
                return (
                  <View style={{ flex: 1, alignSelf: "center" }}>
                    <Value
                      layers
                      indicator={index}
                      circle
                      value={v}
                      // onLongPress={() => this.toggleTimeline(v)}
                      onPress={() =>
                        RootNavigation.push("Project", { id: v.id })
                      }
                      ref={(ref) => {
                        this[`val_${v.id}`] = ref;
                      }}
                      size={this.SIZE * scaleFactor}
                    />
                    {v.viewTimeline &&
                      !!v.timeline &&
                      v.timeline.length > 0 && (
                        <View style={{ flex: 1 }}>
                          <ScrollView
                            style={this.styles().timeline}
                            contentContainerStyle={[
                              this.styles().timelineContentRow,
                            ]}
                          >
                            <View style={[this.styles().datePickerWrapper]}>
                              <Text style={this.styles().title}>Timeline:</Text>
                            </View>
                            <Timeline
                              value={v}
                              wrapperStyle={{ maxWidth: 300 }}
                              size={this.SIZE * CHILD_RATIO}
                            />
                          </ScrollView>
                        </View>
                      )}
                  </View>
                );
              }}
            />
          )}
        </View>
      );
  };

  renderFutureRevisions = () => {
    let { value, hideRevisions, revisionsLoading, revisions, revising } =
      this.state;
    if (value.id == "journal") return null;
    let revisionIds = [...(value.revision_ids || [])].filter(
      (id) => id != value.id,
    );
    let futureRevisionIds = revisionIds.filter((id) => id > value.id);

    let reviseButton = null;
    let allowRevise = !futureRevisionIds?.length;
    allowRevise = true;
    if (revising) {
      let color = valueHelpers.getColor(value, this.context.colorScheme);
      reviseButton = (
        <View
          style={{
            flexDirection: "row",
          }}
        >
          <TouchableOpacity
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "flex-start",
            }}
            onPress={this.handleRevise}
          >
            <HoverableTooltip text="Submit" rightAligned={false}>
              <View style={{ height: 40, justifyContent: "center" }}>
                <MaterialCommunityIcons
                  name="refresh"
                  size={70}
                  color={color}
                />
                <View
                  style={{
                    ...StyleSheet.absoluteFillObject,
                    left: -4,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Entypo name={"check"} size={18} color={color} />
                </View>
              </View>
            </HoverableTooltip>
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "flex-start",
              marginLeft: this.context.sizes.large,
            }}
            onPress={() => this.setState({ revising: false })}
          >
            <HoverableTooltip text="Cancel" rightAligned={false}>
              {/*<Text trim>Cancel</Text>*/}
              <View style={{ height: 40, justifyContent: "center" }}>
                <MaterialCommunityIcons
                  name="refresh"
                  size={40}
                  color={this.context.colors.trim}
                />
                <View
                  style={{
                    ...StyleSheet.absoluteFillObject,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text bold center style={{ color: this.context.colors.trim }}>
                    x
                  </Text>
                </View>
              </View>
            </HoverableTooltip>
          </TouchableOpacity>
        </View>
      );
    } else if (allowRevise) {
      let ripe = valueHelpers.getRipe(value);
      let color = this.context.colors.fill;
      if (ripe) {
        color = valueHelpers.getColor(value, this.context.colorScheme);
        if (!this.ripePulseAnim) {
          this.ripePulseAnim = new Animated.Value(1);
          Animated.loop(
            Animated.sequence([
              Animated.timing(this.ripePulseAnim, {
                toValue: 1.4,
                duration: 500,
                useNativeDriver: !ENV.WEB,
              }),
              Animated.timing(this.ripePulseAnim, {
                toValue: 1.0,
                duration: 1000,
                useNativeDriver: !ENV.WEB,
              }),
              Animated.delay(2000),
            ]),
            // {
            //   iterations: 3,
            // }
          ).start();
        }
      }
      reviseButton = (
        <TouchableOpacity
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "flex-start",
          }}
          onPress={() => {
            this.startRevising();
          }}
        >
          <HoverableTooltip text="Begin revising" rightAligned={false}>
            <Animated.View
              style={{ transform: [{ scale: this.ripePulseAnim || 1 }] }}
            >
              <View
                style={
                  {
                    // transform: [{ rotate: "45deg" }],
                  }
                }
              >
                <MaterialCommunityIcons
                  name="refresh"
                  size={40}
                  color={color}
                />
              </View>
              <View
                style={{
                  ...StyleSheet.absoluteFillObject,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text bold center style={{ color }}>
                  +
                </Text>
              </View>
            </Animated.View>
          </HoverableTooltip>
        </TouchableOpacity>
      );
    }

    return (
      <View
        style={{
          flex: 1,
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        {!revisionsLoading &&
          !!revisionIds?.length &&
          !!revisions?.length &&
          !!futureRevisionIds?.length && (
            <View style={{ flex: 1 }}>
              <FlatList
                horizontal
                style={{
                  flex: 1,
                  opacity: 0.9,
                }}
                // inverted
                data={revisions.filter((r) => futureRevisionIds.includes(r.id))}
                keyExtractor={(item) => `val=${item.id}`}
                renderItem={({ item, index }) => {
                  // future revisions
                  let v = item;
                  let length = 3;
                  let i = length - index;
                  let scaleFactor = Math.max(0, 0.3 * (i / length));
                  scaleFactor += 0.5;
                  return (
                    <View style={{ flex: 1, alignSelf: "center" }}>
                      <Value
                        layers
                        indicator={index}
                        circle
                        value={v}
                        // onLongPress={() => this.toggleTimeline(v)}
                        onPress={() =>
                          RootNavigation.push("Project", { id: v.id })
                        }
                        ref={(ref) => {
                          this[`val_${v.id}`] = ref;
                        }}
                        size={this.SIZE * scaleFactor}
                      />
                      {v.viewTimeline &&
                        !!v.timeline &&
                        v.timeline.length > 0 && (
                          <View style={{ flex: 1 }}>
                            <ScrollView
                              style={this.styles().timeline}
                              contentContainerStyle={[
                                this.styles().timelineContentRow,
                              ]}
                            >
                              <View style={[this.styles().datePickerWrapper]}>
                                <Text style={this.styles().title}>
                                  Timeline:
                                </Text>
                              </View>
                              <Timeline
                                value={v}
                                wrapperStyle={{ maxWidth: 300 }}
                                size={this.SIZE * CHILD_RATIO}
                              />
                            </ScrollView>
                          </View>
                        )}
                    </View>
                  );
                }}
              />
            </View>
          )}
        {reviseButton}
      </View>
    );

    // let revisionIds = [...(value.revision_ids || [])];
    // let futureRevisionIds = revisionIds.filter((id) => id > value.id);
    // if (!futureRevisionIds?.length) return <View style={{ flex: 1 }} />;
    // else if (hideRevisions)
    //   return (
    //     <View style={{ flex: 1, justifyContent: "center" }}>
    //       <TouchableOpacity
    //         style={{ flex: 1, justifyContent: "center" }}
    //         onPress={() => this.setState({ hideRevisions: false })}
    //       >
    //         <Text trim center>
    //           Show future revisions
    //         </Text>
    //       </TouchableOpacity>
    //     </View>
    //   );
    // else return null;

    return (
      <Animated.View style={{ flex: 1 }}>
        {hideRevisions ? (
          futureRevisions?.length ? (
            <TouchableOpacity
              style={{
                flex: 1,
                justifyContent: "center",
              }}
              onPress={() => this.setState({ hideRevisions: false })}
            >
              <Text trim>Show future revisions</Text>
            </TouchableOpacity>
          ) : (
            <View style={{ flex: 1 }} />
          )
        ) : (
          <FlatList
            horizontal
            style={{ flex: 1, opacity: 0.9 }}
            data={futureRevisions}
            keyExtractor={(item) => `val-${item.id}`}
            renderItem={({ item, index }) => {
              // future revisions
              let v = item;
              // let length = Math.min(3, pastRevisions.length-1)
              let length = 3;
              let i = length - index;
              let scaleFactor = Math.max(0, 0.3 * (i / length));
              scaleFactor += 0.5;

              return (
                <View style={{ flex: 1, alignSelf: "center" }}>
                  <Value
                    layers
                    value={v}
                    // onLongPress={() => this.toggleTimeline(v)}
                    onPress={() => RootNavigation.push("Project", { id: v.id })}
                    ref={(ref) => {
                      this[`val_${v.id}`] = ref;
                    }}
                    size={this.SIZE * scaleFactor}
                  />
                  {v.viewTimeline && !!v.timeline && v.timeline.length > 0 && (
                    <View style={{ flex: 1 }}>
                      <ScrollView
                        style={this.styles().timeline}
                        contentContainerStyle={[
                          this.styles().timelineContentRow,
                        ]}
                      >
                        <View style={[this.styles().datePickerWrapper]}>
                          <Text style={this.styles().title}>Timeline:</Text>
                        </View>
                        <Timeline value={v} wrapperStyle={{ maxWidth: 300 }} />
                      </ScrollView>
                    </View>
                  )}
                </View>
              );
            }}
          />
        )}
      </Animated.View>
    );
  };

  deleteDoneAt = async (date) => {
    let { value } = this.state;
    let event = value.timeline.find(
      (event) => event.timestamp == date && event.type == "progress",
    );
    let note = event.note;
    let removeIndex = value.progress_at.indexOf(date);
    console.log(event);

    // reindexing notes is troublesome, so only allow the most recent progress to be deleted
    if (removeIndex != 0) {
      alert("Only the most recent event can be deleted");
      return;
    }

    if (event.type != "progress") {
      alert("Cannot delete special events");
      return;
    }

    let extraWarning = !!note
      ? " Associated note will be deleted as well."
      : "";
    let confirm = await valueActions.confirm(
      "delete",
      "",
      `Delete event?${extraWarning}`,
    );
    if (!confirm) return;

    value.progress_at.splice(removeIndex, 1);
    if (!!note) {
      let noteIndex = value.notes.indexOf(note);
      value.notes.splice(noteIndex, 1);
    }
    let updatedVal = await apiActions.request(`values/${value.id}`, "PATCH", {
      value,
    });
    if (!!updatedVal) {
      value = { ...value, timeline: updatedVal.timeline };
      // value = valueHelpers.applyColorsFromFamily(value)
      this.setState({ value });
      valueActions.updateValues(value);
    }
  };

  handleRevise = async () => {
    let { value, revision } = this.state;
    let data = {
      ...revision,
      text: "",
      title: !!revision.title?.length
        ? revision.title
        : value.title || value.text,
      id: value.id,
      achievement: "",
      finalReflections: revision.finalReflections,
    };
    console.log("REVISE", revision);
    let newVal = await valueActions.revise(data);
    console.log(newVal);
    if (newVal) {
      this.setState({ revising: false });
      RootNavigation.push("Project", { id: newVal.id });
    }
  };

  handleComplete = async (timestamp = new Date().toUTCString()) => {
    let { value } = this.state;
    value = await valueActions.complete(value);
    if (!!value) {
      this.setState({ value });
    }
  };

  handleProgress = async () => {
    let { value } = this.state;
    let res = await valueActions.progress(value.id);
    if (!!res?.value) {
      this.setState({ value: res.value });
    }
  };

  handleCopyUrl = () => {
    let { value } = this.state;
    let url;

    if (ENV.WEB && typeof window !== 'undefined') {
      url = window.location.href;
    } else {
      url = `${ENV.ROOT}Project?id=${value.id}`;
    }

    clipboardHelpers.copy(url);
    Alert.alert("Copied", "URL copied to clipboard");
  };

  handleSnooze = async () => {
    let days = prompt("snooze for how many days?");
    if (!!!days) return;

    let snoozeUntil = new Date();
    snoozeUntil.setHours(24 * days, 0, 0, 0);
    snoozeUntil = snoozeUntil.toUTCString();

    let { value } = this.state;
    value.snooze_until = snoozeUntil;
    value = await apiActions.request(`values/${value.id}`, "PATCH", { value });
    console.log(value);
  };

  handleArchive = async () => {
    let { value, bulkSelectIds } = this.state;
    let data = {};
    if (!!bulkSelectIds?.length) {
      alert("bulk selecting?");
      return;
      let action = `${!!value.archived_at ? "Una" : "A"}rchive`;
      let confirm = await valueActions.confirm(
        action.toLowerCase(),
        "",
        `${action} ${bulkSelectIds.length} items?`,
      );
      if (!confirm) return;
      data.bulk_ids = bulkSelectIds;
    }
    data.archived_at = !!value.archived_at ? false : new Date().toISOString();
    // value = await apiActions.request(`values/${value.id}`, 'PATCH', data)
    value = await valueActions.update(value.id, data);
    // valueActions.update(this.state.value.id, {parent_ids: reorderedParentIds})
    console.log(value);
    if (!!value) this.setState({ value, bulkSelectIds: [] });
  };

  handleHide = async () => {
    let { value, hiddenIds } = this.state;
    if (hiddenIds.includes(value.id)) {
      await prefActions.unhideValue(value.id);
    } else {
      await prefActions.hideValue(value.id);
    }
  };

  // getNextGeneration = (value, relationship, recursively = true) => {
  //   let res = [];
  //   let nextGen =
  //     relationship == "parents"
  //       ? valueHelpers.getParents({value})
  //       : valueHelpers.getChildren({ value });
  //   if (!!nextGen.length) {
  //     if (relation)
  //       nextGen.forEach((v) => {
  //         res.push(v);
  //         if (recursively) {
  //           res = [...res, ...this.getNextGeneration(v, relationship)];
  //         }
  //       });
  //   }
  //   return res;
  // };

  fetchRevisions = async () => {
    let { value } = this.state;
    await this.setState({
      hideRevisions: false,
      revisionsLoading: true,
    });
    let res = await valueActions.getRevisions(value.id);
    if (res?.success) {
      this.setState({ revisions: res.values });
    }
    this.setState({ revisionsLoading: false });
  };

  fetchHistory = async () => {
    let { value, loadingHistory } = this.state;
    this.setState({ loadingHistory: true });
    let res = await valueActions.fetchMoments(value.id);
    if (res.success) {
      console.error(res.moments);
      // let moments = res.moments.map((m) => ({
      //   ...m,
      //   value,
      //   timestampe: m.completed_at || m.created_at,
      // }));
      // let chapterSlots = this.formatSlots(moments).slots;
      // console.log("chapter slots", chapterSlots);
      let moments = [...res.moments]
        .sort((a, b) => {
          let compA = a.chapter?.start_at;
          let compB = b.chapter?.start_at;
          if (!compA) {
            return -1;
          } else if (!compB) {
            return 1;
          } else if (compA == compB) {
            return a.chapter.range > b.chapter.range;
          } else {
            return compA > compB ? 1 : -1;
          }
        })
        .reverse();

      await this.setState({
        loadingHistory: false,
        // moments: textHelpers.oldestFirst(res.moments, 'timestamp'),
        moments,
        // chapters: res.chapters,
        momentTimestamps: res.timestamps,
      });
    }
  };

  handleUpdate = async (val) => {
    // let newValues = this.state.values.map(v => v.id == val.id ? {...v, ...val} : v)
    // newValues = valueHelpers.sortByTimeline(newValues)
    // newValues = valueHelpers.applyLevels(newValues)
    // storageActions.saveItem('values', newValues)
    // this.setState({values: newValues, query: ''})
    let { value } = this.state;
    if (value.id == val.id) value = val;
    let values = await storageActions.fetchItem("values", []);
    await this.setState({ values, value });
  };

  toggleSorting = (column) => {
    let { sorting } = this.state;
    let sortingOptions = [
      "updated",
      "created",
      "completed",
      "inherited",
      "manual",
    ];
    let currentSorting = sorting[column];
    let currentIndex = sortingOptions.indexOf(currentSorting);
    let nextIndex = currentIndex + 1;
    if (nextIndex > sortingOptions.length - 1) nextIndex = 0;
    let nextSorting = sortingOptions[nextIndex];
    sorting[column] = nextSorting;
    this.setState({ sorting });
  };

  startRevising = () => {
    let { value } = this.state;

    // only inherit active children
    let children = valueHelpers.getChildren({ value });
    let active = children.filter(
      (c) =>
        !c.completed_at && !c.snooze_until && !c.archived_at && c.cycle !== 0,
    );
    let ongoing = children.filter(
      (c) =>
        c.cycle === 0 && !c.completed_at && !c.snooze_until && !c.archived_at,
    );
    let openChildIds = [
      ...active.map((v) => v.id),
      ...ongoing.map((v) => v.id),
    ];

    // set notches from active children
    let notches = value.notches.notches.filter((n) =>
      openChildIds.includes(n.value_id),
    );
    let closedNotches = notches.filter((n) => !!n.weight);
    let openNotches = notches.filter((n) => !n.weight);

    let parentIds = valueHelpers
      .getParents({
        value,
        filterToActive: true,
        includePreviousRevisions: false,
      })
      .map((p) => p.id);

    this.setState(
      {
        revising: true,
        revision: {
          ...value,
          title: "",
          text: "",
          id: value.id + 9999999,
          percent: 0,
          progress_at: [],
          parent_ids: parentIds,
          child_ids: openChildIds,
          notches: {
            notches,
            open_notches: openNotches,
            closed_notches: closedNotches,
          },
        },
      },
      () => {
        this.ripePulseAnim = undefined;
        console.log("revision:", this.state.revision);
      },
    );
    this.fetchRevisions();
  };

  toggleRevisingChildId = (id) => {
    let { revision, value } = this.state;
    let childIds = [...revision.child_ids];
    if (childIds.includes(id)) {
      childIds.splice(childIds.indexOf(id), 1);
    } else {
      childIds.push(id);
    }
    // notches
    let notches = value.notches.notches.filter((n) =>
      childIds.includes(n.value_id),
    );
    let closedNotches = notches.filter((n) => !!n.weight);
    let openNotches = notches.filter((n) => !n.weight);
    console.log(revision);
    this.setState({
      revision: {
        ...revision,
        child_ids: childIds,
        notches: {
          notches,
          open_notches: openNotches,
          closed_notches: closedNotches,
        },
      },
    });
  };

  toggleRevisingParentId = (id) => {
    let { revision, value } = this.state;
    let parentIds = [...revision.parent_ids];
    if (parentIds.includes(id)) {
      parentIds.splice(parentIds.indexOf(id), 1);
    } else {
      parentIds.push(id);
    }
    console.log(revision);
    this.setState({
      revision: {
        ...revision,
        parent_ids: parentIds,
      },
    });
  };

  rotateSortChildrenBy = () => {
    let sortOptions = ["progress", "manual", "created", "updated"];
    let { sortChildrenBy } = this.state;
    let index = sortOptions.indexOf(sortChildrenBy);
    index = index + 1;
    if (index > sortOptions.length - 1) index = 0;
    sortChildrenBy = sortOptions[index];
    this.setState({ sortChildrenBy });
  };

  scrollToHeader = (animated = true, maxDistanceToScroll = null) => {
    // console.log("scrolling to header", !!this.pensieveRef);
    !!this.pensieveRef &&
      this.pensieveRef.measure((x, y, width, height, pageX, pageY) => {
        let toolbarHeight = 64;
        let targetScrollPos = pageY - toolbarHeight;
        console.error(y, pageY, targetScrollPos);
        if (
          !!maxDistanceToScroll &&
          Math.abs(targetScrollPos) > maxDistanceToScroll
        ) {
          return;
        } else {
          console.error("scrolling!", targetScrollPos);
        }
        !!this.scrollerRef &&
          this.scrollerRef.scrollTo({
            y: targetScrollPos,
            animated,
          });
        setTimeout(
          () => {
            this.setState({ layoutComplete: true });
          },
          0, //animated ? 400 : 0
        );
      });
  };

  styles = () => ({
    content: {
      flexDirection: "column",
      flex: 1,
      alignItems: "stretch",
      // justifyContent: 'space-around',
      // borderWidth: 1, borderColor: 'red',
    },
    sectionsRow: {
      flexDirection: "row",
      // maxHeight: 300,
      // maxHeight: this.context.pensieve ? 600 : 400,
      // height: this.context.pensieve ? 600 : 400,
    },
    sectionCol: {
      flex: 1,
      // maxWidth: WIDTH / 4,
      minWidth: 300,
      minHeight: 300,
    },
    section: {
      // flex: 1,
      justifyContent: "center",
      // borderWidth: 1, borderColor: 'white',
    },
    headerRow: {
      padding: this.context.sizes.base,
      borderBottomWidth: 1,
      borderColor: this.context.colors.trim,
    },
    headerRowContent: {
      flexDirection: "row",
      alignSelf: "stretch",
      justifyContent: "space-around",
      flexWrap: "wrap",
      zIndex: 2,
    },
    contentRow: {
      // flex: 1,
      flexDirection: "row",
      marginTop: this.context.sizes.giant,
      marginBottom: this.context.sizes.large,
      // marginHorizontal: this.context.sizes.giant,
      alignSelf: "stretch",
      alignItems: "stretch",
      justifyContent: "center",
      zIndex: -1,
      // minHeight: HEIGHT / 3,
      // minHeight: (HEIGHT - 110 - 243 - 60) / 2,
      // alignItems: "center",
      // borderWidth: 2, borderColor: 'red',
    },
    title: {
      zIndex: -1,
      // borderBottomWidth: 1,
      borderBottomColor: this.context.colors.trim,
      // alignSelf: 'stretch',
      // flex: 1,
      flexDirection: "row",
      justifyContent: "space-between",
    },
    row: {
      zIndex: -1,
      flex: -1,
      flex: 1,
      flexDirection: "row",
      alignSelf: "stretch",
      justifyContent: "space-around",
      flexWrap: "wrap",
      flexWrap: "nowrap",
      // paddingLeft: this.context.sizes.base,
      // borderWidth: 2, borderColor:'red',
    },
    wrapRow: {
      // flex: -1,
      flexWrap: "wrap",
    },
    col: {
      zIndex: -1,
      flex: 1,
      flexDirection: "column",
      alignSelf: "stretch",
      justifyContent: "flex-start",
      alignItems: "center",
      flexWrap: "nowrap",
      paddingTop: this.context.sizes.base,
      // borderColor: 'blue', borderWidth: 1,
    },
    colReverse: {
      flexDirection: "column-reverse",
    },
    input: {
      ...styleSheet.input,
      // height: this.context.sizes.itemHeight,
      marginHorizontal: this.context.sizes.base,
      marginTop: 0,
      // flex: 1,
      alignSelf: "stretch",
    },
    multilineInput: {
      height: 200,
    },
    timeline: {
      zIndex: 1,
      borderWidth: 1,
      borderColor: this.context.colors.fill,
      // minHeight: 200,
      // minWidth: 100,
      // flex: 1,
      // maxWidth: 300,
    },
    timelineContentRow: {
      zIndex: -1,
      // paddingBottom: 100,
      // borderColor: 'red', borderWidth: 1,
      // flexGrow: 0,
    },
    datePickerWrapper: {
      // flex: 1,
      // paddingBottom: 100,
    },
    iconWrapper: {
      flexDirection: "row",
      marginLeft: this.context.sizes.base,
    },
    icon: {
      marginLeft: this.context.sizes.base,
      fontSize: this.context.sizes.large,
      width: this.context.sizes.large,
    },
    iconRing: {
      borderWidth: 2,
      borderColor: this.context.colors.foreground,
      borderRadius: 99,
      padding: ENV.WEB ? 0 : 2,
      // borderRadius: (this.context.sizes.large+4)/2,
      width: this.context.sizes.large + 4,
      height: this.context.sizes.large + 4,
      // textAlign: 'center',
    },
    generationRow: {
      flexDirection: "row",
      justifyContent: "flex-start",
      justifyContent: "center",
      // flex: 1,
      // borderWidth: 5, borderColor: 'red',
      width: "100%",
      // flexWrap: 'wrap',
    },
    dot: {
      width: this.context.sizes.base,
      height: this.context.sizes.base,
      borderRadius: this.context.sizes.base,
      marginLeft: this.context.sizes.base,
    },
    headerIconWrapper: {
      width: this.context.sizes.giant * 1.3,
      height: this.context.sizes.giant * 1.3,
      borderRadius: this.context.sizes.giant,
      justifyContent: "center",
      alignItems: "center",
      marginRight: this.context.sizes.base,
    },
  });
}
